<script>
    export let title;
    export let date;
    export let description;
    export let imageUrl;
    export let githubLink;
    export let youtubeLink;
    export let location;
    export let zoomLink;   // New Zoom link export
    export let rsvpLink;   // New RSVP link export
    export let category;
    export let difficulty;
    export let semester;
    
    let isExpanded = false; // State to track if the description is expanded
    const maxLength = 100; // Reduced from 200 to ensure more events have "See More"
</script>

<div class="workshop-container">
    <div class="workshop-card">
        <div class="workshop-content">
            <div class="workshop-header">
                <div class="title-section">
                    <h2 class="workshop-title">{title}</h2>
                    <div class="badges-container">
                        <span class="category-badge">{category}</span>
                        <span class="difficulty-badge {difficulty.toLowerCase()}">{difficulty}</span>
                        <span class="semester-badge">{semester}</span>
                    </div>
                </div>
                <div class="date-section">
                    <div class="date-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.31-8.86c-1.77-.45-2.34-.94-2.34-1.67 0-.84.79-1.43 2.1-1.43 1.38 0 1.9.66 1.94 1.64h1.71c-.05-1.34-.87-2.57-2.49-2.97V5H10.9v1.69c-1.51.32-2.72 1.3-2.72 2.81 0 1.79 1.49 2.69 3.66 3.21 1.95.46 2.34 1.15 2.34 1.87 0 .53-.39 1.39-2.1 1.39-1.6 0-2.23-.72-2.32-1.64H8.04c.1 1.7 1.36 2.66 2.86 2.97V19h2.34v-1.67c1.52-.29 2.72-1.16 2.73-2.77-.01-2.2-1.9-2.96-3.66-3.42z"/>
                        </svg>
                    </div>
                    <span class="date-text">{date}</span>
                </div>
            </div>

            <div class="workshop-body">
                <div class="description-section">
                    <p class="description">
                        {isExpanded || description.length <= maxLength
                            ? description
                            : description.substring(0, maxLength) + '...'}
                        {#if description.length > maxLength}
                        <button
                            on:click={() => isExpanded = !isExpanded}
                            class="expand-button">
                            {isExpanded ? 'See Less' : 'See More'}
                        </button>
                        {/if}
                    </p>
                </div>

                {#if isExpanded}
                    <div class="location-section">
                        <div class="location-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                            </svg>
                        </div>
                        <span class="location-text">{location}</span>
                    </div>

                    <div class="links-section">
                        {#if githubLink}
                            <a href={githubLink} class="link-button github" target="_blank">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                                </svg>
                                GitHub
                            </a>
                        {/if}
                        {#if youtubeLink}
                            <a href={youtubeLink} class="link-button youtube" target="_blank">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"/>
                                </svg>
                                YouTube
                            </a>
                        {/if}
                        {#if zoomLink}
                            <a href={zoomLink} class="link-button zoom" target="_blank">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z"/>
                                </svg>
                                Join Zoom
                            </a>
                        {/if}
                        {#if rsvpLink}
                            <a href={rsvpLink} class="link-button rsvp" target="_blank">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1V19z"/>
                                </svg>
                                RSVP
                            </a>
                        {/if}
                    </div>
                {/if}
            </div>
        </div>

        {#if imageUrl && isExpanded}
            <div class="image-container">
                <img 
                    src={imageUrl} 
                    alt="{title}" 
                    class="workshop-image" 
                    loading="lazy"
                    decoding="async"
                />
            </div>
        {/if}
    </div>
</div>

<style>
    .workshop-container {
        display: flex;
        justify-content: center;
        animation: slideInRight 2s ease forwards;
    }

    .workshop-card {
        background: linear-gradient(135deg, #1a1a1a, #2a2a2a);
        border-radius: 20px;
        overflow: hidden;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
        display: flex;
        flex-direction: column;
        max-width: 900px;
        transition: transform 0.3s ease, box-shadow 0.3s ease;
        position: relative;
    }

    .workshop-card:hover {
        transform: translateY(-5px);
        box-shadow: 0 15px 35px rgba(0, 0, 0, 0.4);
    }

    .workshop-content {
        padding: 2rem;
        color: white;
        position: relative;
        z-index: 1;
    }

    .workshop-header {
        margin-bottom: 1.5rem;
    }

    .title-section {
        margin-bottom: 1rem;
    }

    .workshop-title {
        font-size: 1.8rem;
        font-weight: bold;
        margin-bottom: 0.5rem;
        background: linear-gradient(45deg, #FF4433, #FFD520);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    .date-section {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        color: #888;
    }

    .date-icon, .location-icon {
        width: 20px;
        height: 20px;
        color: #FF4433;
    }

    .workshop-body {
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
    }

    .description {
        line-height: 1.6;
        color: #ddd;
    }

    .expand-button {
        background: none;
        border: none;
        color: #FF4433;
        cursor: pointer;
        padding: 0;
        margin-left: 0.5rem;
    }

    .location-section {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        color: #888;
    }

    .links-section {
        display: flex;
        flex-wrap: wrap;
        gap: 1rem;
        margin-top: 1rem;
    }

    .link-button {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.5rem 1rem;
        border-radius: 8px;
        color: white;
        text-decoration: none;
        transition: transform 0.3s ease;
    }

    .link-button:hover {
        transform: translateY(-2px);
    }

    .link-button svg {
        width: 20px;
        height: 20px;
    }

    .github {
        background: #333;
    }

    .youtube {
        background: #ff0000;
    }

    .zoom {
        background: #2d8cff;
    }

    .rsvp {
        background: #FF4433;
    }

    .image-container {
        width: 100%;
        height: 250px;
        position: relative;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .workshop-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.5s ease;
    }

    .image-container::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(180deg, rgba(26, 26, 26, 0) 0%, rgba(26, 26, 26, 0.8) 100%);
        z-index: 1;
    }

    .image-container:hover .workshop-image {
        transform: scale(1.05);
    }

    .badges-container {
        display: flex;
        flex-wrap: wrap;
        gap: 0.5rem;
        margin-bottom: 1rem;
    }

    .category-badge, .difficulty-badge, .semester-badge {
        padding: 0.25rem 0.75rem;
        border-radius: 15px;
        font-size: 0.8rem;
        font-weight: 500;
    }

    .category-badge {
        background: rgba(255, 68, 51, 0.2);
        color: #FF4433;
    }

    .difficulty-badge {
        background: rgba(255, 212, 32, 0.2);
        color: #FFD520;
    }

    .semester-badge {
        background: rgba(0, 123, 255, 0.2);
        color: #007bff;
    }

    .difficulty-badge.beginner {
        background: rgba(0, 255, 0, 0.2);
        color: #00ff00;
    }

    .difficulty-badge.intermediate {
        background: rgba(255, 255, 0, 0.2);
        color: #ffff00;
    }

    .difficulty-badge.advanced {
        background: rgba(255, 0, 0, 0.2);
        color: #ff0000;
    }

    @media (max-width: 768px) {
        .workshop-card {
            max-width: 100%;
        }

        .workshop-content {
            padding: 1.5rem;
        }

        .workshop-title {
            font-size: 1.5rem;
        }

        .description {
            font-size: 0.9rem;
        }

        .link-button {
            width: 100%;
            justify-content: center;
        }

        .image-container {
            height: 200px;
        }

        .link-button svg {
            width: 16px;
            height: 16px;
        }
    }

    @media (max-width: 480px) {
        .workshop-content {
            padding: 1rem;
        }

        .workshop-title {
            font-size: 1.3rem;
        }

        .badges-container {
            gap: 0.25rem;
        }

        .category-badge, .difficulty-badge, .semester-badge {
            font-size: 0.7rem;
            padding: 0.2rem 0.5rem;
        }

        .links-section {
            flex-direction: column;
        }

        .image-container {
            height: 180px;
        }

        .link-button svg {
            width: 14px;
            height: 14px;
        }
    }

    @keyframes slideInRight {
        from {
            transform: translateX(100%);
            opacity: 0;
        }
        to {
            transform: translateX(0);
            opacity: 1;
        }
    }

    .filter-select {
        padding: 0.5rem 1rem;
        border: none;
        border-radius: 8px;
        background: #1a1a1a;
        color: white;
        cursor: pointer;
        width: 100%;
        transition: all 0.3s ease;
        font-size: 0.9rem;
    }

    .filter-select option {
        background: #1a1a1a;
        color: white;
        padding: 0.5rem;
    }
</style>
